import { StyleSheet } from "react-native"
import { typography } from "../../theme/typography"
import { colors } from "colors"

export const style = StyleSheet.create({
  text: {
    color: colors.black,
    fontFamily: typography.primary.normal,
  },
})
